import { getcabKey } from "@/api/system";
import config, { Patform } from "@/config";
import { toDataURL } from "qrcode";

export async function sleep(time = 1000) {
  await new Promise((res) => {
    setTimeout(() => {
      res("");
    }, time);
  });
}


export async function gecabtkey(order_id: number | string, room_id?: number | string) {
  if (config.env == Patform.wechat) {
    const {
      data: {
        weixin: { openlink, jump_query },
        notTime,
      },
    } = await getcabKey({ room_id });
    if (!notTime) throw "未到开锁时间！";
    
    if (isDevMiniProgram()) {
      //预上线环境
      const link = jump_query;
      console.log("link", link);
      const v = await toDataURL(link);
      const img = document.createElement("img");
      img.src = v;
      img.style.position = "fixed";
      img.style.top = "0";
      img.style.left = "0";
      img.style.zIndex = "99999";
      img.style.width = "100%";
      img.ondblclick = () => {
        document.body.removeChild(img);
      };
      document.body.appendChild(img);
      // 双击关闭（容器）
      img.ondblclick = () => {
        document.body.removeChild(img);
      };
      return
    }
    
    const a = document.createElement("a");
    a.href = openlink;
    a.click();
    return;
  }
  if (config.env == Patform.alipay) {
    uni.navigateTo({ url: `/pages/keys/keys?${order_id ? 'cab_order=' + order_id : ''}${room_id ? '&room_id=' + room_id : ''}` });
    return;
  }
  throw "请使用微信或支付宝获取钥匙";
}

export function img(src: string) {
  src = src.trim()
  if(config.isdev && src=="" )return "http://www.dmoe.cc/random.php"
  if (src.substring(0, 4) == 'http') {
    src = src.replace('https', 'http')
    if (location.href.includes('https')) {
      src = src.replace('http', 'https')
    }
  }
  return src
}

let taskarriv = null as any
export async function taskArr(target: any[], src: any, step = 2, time = 16) {
  target.slice(0, target.length)
  //@ts-ignore
  taskarriv && clearInterval(taskarriv)
  let cindex = 0
  taskarriv = setInterval(() => {
    for (let index = 0; index < step; index++) {
      const elindex = cindex + index;
      if (elindex >= src.length) {
        clearInterval(taskarriv)
        taskarriv = null
        break
      }
      target.push(src[elindex])
    }
    cindex += step
  }, time)
}

// 是否跳转预上线小程序
export const isDevMiniProgram = () => {
  let isDev = false;
  config.whiteHost?.forEach((host: string) => {
    if (window.location.href.includes(host)) {
      isDev = true;
    }
  })
  return isDev;
}

// 判断是否有上一页的通用函数
export const hasPreviousPage = () => {
  const pages = getCurrentPages();
  return pages && pages.length > 1;
}

// 获取search中是的参数
export const getHash = (name: string) => {
  const hash = window.location.hash;
  if (hash.includes('?')) {
    const queryString = hash.split('?')[1];
    const params = new URLSearchParams(queryString);
    return params.get(name);
  } else {
    return;
  }
}

// 删除search中的参数但不刷新页面
export const removeHash = (name: string) => {
  const hash = window.location.hash
  if (!hash.includes(name + '=')) return
  
  // 分离路径和参数
  const [pathPart, queryPart] = hash.split('?')
  if (!queryPart) return
  
  // 移除openid参数
  const params = new URLSearchParams(queryPart)
  params.delete(name)
  
  // 构建新的hash
  const newQuery = params.toString()
  const newHash = newQuery ? `${pathPart}?${newQuery}` : pathPart
  
  // 更新URL（不刷新页面）
  window.history.replaceState({}, '', window.location.pathname + newHash)
}